<section class="climatic-filters">
  <!-- box header -->
  <div class="climatic-filters__header" (click)="setIsBoxOpened()">
    <div class="box-title">
      <!-- box icon -->
      <span class="box-title__icon">
        <i class="iconsax" [attr.icon-name]="boxIcon()"></i>
      </span>
      <!-- box title -->
      <h3 class="box-title__text">
        {{ boxTitle() | translate }}
      </h3>
    </div>

    <!-- box toggle btn -->
    @if (isClosableBox()) {
      <button class="box-toggle-btn">
        <i
          class="iconsax"
          [attr.icon-name]="isBoxOpened ? 'chevron-up' : 'chevron-down'"></i>
      </button>
    }
  </div>

  <!-- box filters -->
  @if (isBoxOpened) {
    <form
      class="climatic-filters__list custom-scrollbar"
      [formGroup]="climaticFiltersForm">
      @for (item of climaticFilters().filterTitles; track $index) {
        <!-- staged inputs mode -->
        <li>
          <pwj-staged-input
            [label]="item.toString()"
            [formControlName]="
              climaticFilters().filterQueryNames[$index]
            "></pwj-staged-input>
        </li>
      }
    </form>
  }
</section>
